import {
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '../../../models';
import { WaveHandIcon } from '../../waveHandIcon/WaveHandIcon';

import { Header } from '../../Screen';
import { useEffect } from 'react';
import { Card } from '@popsure/dirty-swan';

import styles from './IntroForm.module.scss'
import classNames from 'classnames';

type InfoCard = {
  title: string;
  description?: string;
  icon?: string;
  iconPosition?: 'top' | 'center' | 'bottom';
  iconSize?: 'default' | 'large';
}

type Props<Questionnaire extends QuestionnaireQuestions> = {
  title: string;
  subTitle: string;
  hideIcon?: boolean;
  icon?: string;
  infoCards?: InfoCard[];
  infoCardsDisplay?: 'horizontal' | 'vertical';
} & QuestionnaireFormProps<Questionnaire, boolean>;

export const IntroForm = <Questionnaire extends QuestionnaireQuestions>({
  title,
  subTitle,
  onSubmitValue,
  setValidForSubmission,
  hideIcon = false,
  icon = '',
  infoCards = [],
  infoCardsDisplay = 'vertical',
}: Props<Questionnaire>) => {
  const handleSubmit = () => {
    onSubmitValue(true);
  };

  useEffect(() => {
    setValidForSubmission(true);
  });

  const renderIcon = () => {
    if (hideIcon) {
      return;
    }

    if (!icon) {
      return <WaveHandIcon />;
    }

    return <img src={icon} width="136" alt="" />
  }

  const isHorizontal = infoCardsDisplay === 'horizontal';

  return (
    <Header onSubmit={handleSubmit}>
      <div className="p-body mx0">
        {renderIcon()}
        <h1 className="p-h1 mt16">{title}</h1>
        <p className="p-p my16">{subTitle}</p>
        <div className={`d-flex gap16 ${isHorizontal ? styles.horizontalLayout : styles.verticalLayout}`}>
          {infoCards.map(({
            title, 
            description, 
            icon: cardIcon,
            iconPosition,
            iconSize = 'default'
          }, index) => (
            <Card
              title={isHorizontal ? (
                <>
                  <img
                    src={cardIcon}
                    width={iconSize === 'large' ? 104: 64}
                    alt=""
                  />
                  <div>{title}</div>
                </>
              ) :title}
              classNames={{
                wrapper: `wmx8 ${isHorizontal ? classNames(styles.horizontalCard, 'ta-center') : ''}`, 
              }}
              icon={cardIcon && !isHorizontal && <img src={cardIcon} width={32} alt="" />}
              titleVariant='medium'
              description={description}
              descriptionVariant={isHorizontal ? 'small' : 'large'}
              verticalAlignment={iconPosition}
              key={index}
            />
          ))}
        </div>
      </div>
    </Header>
  );
};
